import Vue from 'vue'

const userAgency = {
  state: {
    userAgencies: [],
    selectedUserAgency: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    userAgencies(state) {
      return state.userAgencies
    },
    selectedUserAgency(state) {
      return state.selectedUserAgency
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    userAgencies(state, payload) {
      state.userAgencies = payload
    },
    selectedUserAgency(state, payload) {
      state.selectedUserAgency = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedUserAgency(context, payload) {
      context.commit('selectedUserAgency', payload)
    },
    loadUserAgencies(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'UserAgency'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('userAgencies', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    loadUserAgenciesForUser(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `UserAgency/User/${payload}`
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            // context.commit('userAgencies', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedUserAgency(context, payload) {
      if (
        context.state.selectedUserAgency &&
        context.state.selectedUserAgency.ID
      ) {
        context.dispatch(
          'loadSelectedUserAgency',
          context.state.selectedUserAgency.ID
        )
      }
    },
    loadSelectedUserAgency(context, payload) {
      if (
        context.state.selectedUserAgency &&
        context.state.selectedUserAgency.ID != payload
      ) {
        context.commit('selectedUserAgency', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'UserAgency/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedUserAgency', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadUserAgencies(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadUserAgencies')
      })
    },
    updateUserAgency(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `UserAgency/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'user agency updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadUserAgencies')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createUserAgency(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `UserAgency`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'user agency created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadUserAgencies')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveUserAgency(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateUserAgency', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createUserAgency', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteUserAgency(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `UserAgency/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'user agency deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadUserAgencies')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default userAgency
